import React from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import {
  Auth,
  EmailAuthProvider,
  GoogleAuthProvider,
  getAuth,
} from "firebase/auth";
import firebaseApp from "@src/auth/lib/firebaseClient";
import { Loading } from "@src/common/components";
import * as firebaseui from "firebaseui";
import { useCourieStore } from "@src/common/lib/store";
import { useAuth } from "@src/common/hooks/useAuth";

type Props = {
  authLoading: boolean;
};

export function FirebaseAuthUI({ authLoading }: Props) {
  const { isAuthenticated } = useAuth();
  const { showToast } = useCourieStore();
  const [loading, setLoading] = React.useState(true);  
  const auth: Auth = getAuth(firebaseApp);

  const uiConfig: firebaseui.auth.Config = {
    signInFlow: "popup",
    tosUrl: "/terms-of-service",
    privacyPolicyUrl: "/privacy-policy",
    signInOptions: [
      EmailAuthProvider.PROVIDER_ID,
      GoogleAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccessWithAuthResult: function () {
        return false;
      },
      uiShown: function () {
        // The widget is rendered.
        // Do something?
        setLoading(false);
      },
      signInFailure(error) {
        showToast({
          message: "Something went wrong with the login. Please try again.",
          type: "error",
        });
      },
    },
  };

  // If we have a user, we don't need to show the login page
  if (isAuthenticated) return null;

  // If we're still loading the auth, show a loading spinner
  if (authLoading) return <Loading loading={authLoading} />;

  return (
    <Loading loading={loading}>
      <StyledFirebaseAuth
        uiConfig={uiConfig}
        firebaseAuth={auth}
        className="w-50"
      />
    </Loading>
  );
}
